/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import {
  Col,
  ControlLabel,
  Form,
  FormControl,
  FormGroup,
  Modal,
} from 'react-bootstrap';
import RichButton from 'loracoms/RichButton';
import Select from 'loracoms/Select';
import ControlTips from 'loracoms/ControlTips';
import FormBlock from 'loracoms/FormBlock';
import ErrorSet from 'lorautils/errors/ErrorSet';
import { callAPI } from 'lorautils/api';
import {
  formatDevEUIInput,
  isValidDevEUI,
} from 'lorautils/IdUtils';
import { isHexString } from 'lorautils/checkers/numbers';
import IntlMsg from 'lorautils/intl/IntlMsg';
import { enumsToOptions } from 'lorautils/api/selector';
import RichLabel from 'loracoms/RichLabel';
import styles from './styles.scss';


const defaultProps = {
  show: false,
};

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  appeui: React.PropTypes.string.isRequired,
  onSucc: React.PropTypes.func.isRequired,
  onOOQ: React.PropTypes.func.isRequired,
  onHide: React.PropTypes.func.isRequired,
  bandOpts: React.PropTypes.array.isRequired,
  show: React.PropTypes.bool,
};

class ImportOTAAModal extends React.Component {

  static initErrors() {
    return (
      ErrorSet
        .createEmpty()
        .add('FE_EMPTY', 'deveui')
        .add('FE_EMPTY', 'appkey')
        .add('FE_EMPTY', 'band')
    );
  }

  constructor(props) {
    super(props);
    this.state = {
      show: props.show,
      appeui: props.appeui,
      bandOpts: props.bandOpts,
      errors: ImportOTAAModal.initErrors(),
    };
    this.handleChangeBand = this.handleChangeBand.bind(this);
    this.handleChangeDevEUI = this.handleChangeDevEUI.bind(this);
    this.handleChangeAppKey = this.handleChangeAppKey.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleHide = this.handleHide.bind(this);
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.detailview.devicelist.importotaa');
  }

  componentWillReceiveProps(nextProps) {
    const { bandOpts, show } = nextProps;
    if (show !== this.props.show) {
      this.setState({ show });
    }
    if (bandOpts !== this.props.bandOpts) {
      this.setState({ bandOpts });
    }
  }

  componentDidUpdate() {
    if (!_.isNil(this.cursorPos) && this.activeInput) {
      _.delay(
        () => this.activeInput.setSelectionRange(this.cursorPos, this.cursorPos),
        50,
      );
    }
  }

  reset() {
    this.setState({
      submitted: false,
      deveui: '',
      appkey: '',
      band: '',
      status: '',
      errors: ImportOTAAModal.initErrors(),
    });
  }

  handleChangeDevEUI(e) {
    let { deveui = '' } = this.state;
    deveui = formatDevEUIInput(e.target.value.trim(), deveui);
    this.setState({ deveui });

    this.cursorPos = e.target.selectionEnd;
    if (e.target.value.length === this.cursorPos) {
      this.cursorPos = deveui.length;
    }

    const { errors } = this.state;
    if (deveui === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'deveui') });
    } else if (isValidDevEUI(deveui)) {
      this.setState({ errors: errors.remove('deveui') });
    } else {
      this.setState({ errors: errors.add('FE_INVALIDFORMAT', 'deveui') });
    }
  }

  handleChangeAppKey(e) {
    const appkey = e.target.value.trim();
    this.setState({ appkey });

    const { errors } = this.state;

    if (appkey === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'appkey') });
    } else if (isHexString(appkey, { len: 32 })) {
      this.setState({ errors: errors.remove('appkey') });
    } else {
      this.setState({ errors: errors.add('FE_INVALIDFORMAT', 'appkey') });
    }
  }

  handleChangeBand(band) {
    const { errors } = this.state;
    this.setState({ band, errors: errors.remove('band') });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ submitted: true });

    let { errors } = this.state;
    errors = errors.remove('submit');
    if (!errors.isEmpty()) {
      return;
    }

    const { onSucc, onOOQ, appeui } = this.props;
    const { deveui, appkey, band } = this.state;

    const noSeps = x => x.toUpperCase().replace(/[:-]/g, '');
    callAPI({
      endpoint: '/lora/nodes',
      method: 'POST',
      body: {
        deveui: noSeps(deveui),
        appkey: noSeps(appkey),
        appeui: noSeps(appeui),
        fcntbits: 32,
        band,
      },
    }).then(() => {
      this.setState({
        status: 'success',
        errors: errors.remove('submit'),
      });
      _.delay(() => {
        onSucc();
        this.reset();
      }, 500);
    }).catch((error) => {
      if (error.code === 'QUOTA') {
        onOOQ();
      } else {
        this.setState({
          status: 'error',
          errors: errors.add(error.code, 'submit'),
        });
      }
    });
  }

  handleHide() {
    this.reset();
    this.props.onHide();
  }

  render() {
    const {
      show,
      status = '',
      deveui = '',
      appkey = '',
      band = '',
      bandOpts = [],
      submitted = false,
      errors,
    } = this.state;

    return (
      <Modal
        bsSize="large"
        bsClass="aisz-modal-light"
        backdrop="static"
        show={show}
        onHide={this.handleHide}
      >
        <Modal.Header closeButton>
          <div className="text-center">
            {this.intlMsg.msg('modalheader')}
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className={styles.modalform}>
            <Form horizontal onSubmit={this.handleSubmit}>
              <FormGroup validationState={submitted && errors.has('deveui') ? 'error' : undefined}>
                <Col md={3}>
                  <ControlLabel className="aisz-control-label">DevEUI</ControlLabel>
                </Col>
                <Col md={7}>
                  <FormControl
                    value={deveui}
                    className="aisz-form-control-f"
                    placeholder="01-23-45-67-89-AB-CD-EF"
                    onChange={this.handleChangeDevEUI}
                    inputRef={(ref) => { this.deveuiInputRef = ref; }}
                    onFocus={() => { this.activeInput = this.deveuiInputRef; }}
                    onBlur={() => { this.cursorPos = null; }}
                  />
                  <ControlTips
                    show={submitted && errors.has('deveui')}
                    message={this.intlMsg.errorMsg(errors.get('deveui'))}
                    azStyle="danger"
                  />
                </Col>
              </FormGroup>
              <FormGroup validationState={submitted && errors.has('appkey') ? 'error' : undefined}>
                <Col md={3}>
                  <ControlLabel className="aisz-control-label">AppKey</ControlLabel>
                </Col>
                <Col md={7}>
                  <FormControl
                    value={appkey}
                    className="aisz-form-control-f"
                    placeholder="0123456789ABCDEF0123456789ABCDEF"
                    onChange={this.handleChangeAppKey}
                  />
                  <ControlTips
                    show={submitted && errors.has('appkey')}
                    message={this.intlMsg.errorMsg(errors.get('appkey'))}
                    azStyle="danger"
                  />
                </Col>
              </FormGroup>
              <FormGroup validationState={submitted && errors.has('band') ? 'error' : undefined}>
                <Col md={3}>
                  <ControlLabel className="aisz-control-label">
                    {this.intlMsg.msg('band')}
                  </ControlLabel>
                </Col>
                <Col md={7}>
                  <Select
                    value={band}
                    className="aisz-form-control-f"
                    placeholder={this.intlMsg.msg('band.placeholder')}
                    onChange={this.handleChangeBand}
                    options={bandOpts}
                  />
                  <ControlTips
                    show={submitted && errors.has('band')}
                    message={this.intlMsg.errorMsg(errors.get('band'))}
                    azStyle="danger"
                  />
                </Col>
              </FormGroup>
              <FormGroup>
                <Col mdOffset={3} md={7}>
                  <div className={styles.submit}>
                    <RichButton
                      status={status}
                      states={[{
                        status: 'default',
                        label: this.intlMsg.msg('submit'),
                        type: 'submit',
                        style: 'primary',
                      }, {
                        status: 'pending',
                        label: this.intlMsg.msg('submit.pending'),
                        type: 'submit',
                        style: 'primary',
                      }, {
                        status: 'success',
                        label: this.intlMsg.msg('submit.success'),
                        style: 'success',
                        timer: () => { this.setState({ status: '' }); },
                      }, {
                        status: 'failure',
                        label: this.intlMsg.msg('submit.failure'),
                        style: 'danger',
                        timer: () => { this.setState({ status: '' }); },
                      }]}
                    />
                  </div>
                </Col>
              </FormGroup>
              <FormGroup>
                <Col mdOffset={3} md={7}>
                  <FormBlock
                    show={errors.has('submit')}
                    message={this.intlMsg.errorMsg(errors.get('submit'))}
                    azStyle="danger"
                  />
                </Col>
              </FormGroup>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

ImportOTAAModal.defaultProps = defaultProps;
ImportOTAAModal.propTypes = propTypes;


const mapStateToProps = state => ({
  bandOpts: enumsToOptions('bands', state).map(
    opt => ({ ...opt, formatter: x => <RichLabel content={x} /> })),
});

export default connect(
  mapStateToProps,
  null,
)(injectIntl(ImportOTAAModal));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DetailView/coms/ImportOTAAModal/index.jsx